import Swiper from 'swiper'
import { Navigation, Autoplay, Pagination, EffectFade, FreeMode, Mousewheel, Scrollbar } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/effect-fade'

let config

export const initSwiper = () => {
	const sliders = document.querySelectorAll('[data-swiper]')

	if (!sliders.length) return

	sliders.forEach((slider) => {
		const type = slider.getAttribute('data-swiper')
		const pagination = slider.querySelector('.swiper-pagination')
		const prevEl = slider.querySelector('.swiper-button-prev')
		const nextEl = slider.querySelector('.swiper-button-next')
		const scrollbar = slider.querySelector('.swiper-scrollbar')

		switch (type) {
			case 'swiper':
				config = {
					loop: true,
					slidesPerView: 1.25,
					spaceBetween: 30,
					speed: 1000,
					grabCursor: true,
					modules: [FreeMode],
					freeMode: {
						enabled: true,
					},
					breakpoints: {
						1025: {
							slidesPerView: 4,
							spaceBetween: 30,
						},
						651: {
							slidesPerView: 2.5,
							spaceBetween: 30,
						}
					}
				}
			break;
			case 'latest':
				config = {
					loop: false,
					slidesPerView: 1.1,
					spaceBetween: 20,
					grabCursor: true,
					breakpoints: {
						1025: {
							slidesPerView: 3,
						},
						651: {
							slidesPerView: 2.1,
						}
					}
				}
			break;
			case 'news':
				config = {
					loop: false,
					slidesPerView: 1.1,
					spaceBetween: 20,
					grabCursor: true,
					breakpoints: {
						1025: {
							slidesPerView: 3,
							spaceBetween: 32,
						},
						651: {
							slidesPerView: 2.1,
							spaceBetween: 20,
						}
					}
				}
			break;
			case 'related':
				config = {
					slidesPerView: 1,
					spaceBetween: 12,
					grabCursor: true,
				}
			break;
			case 'values':
				config = {
					slidesPerView: 'auto',
					centeredSlides: true,
					spaceBetween: 20,
					slideToClickedSlide: true,
					grabCursor: true,
					modules: [Scrollbar],
					scrollbar: {
						el: scrollbar,
						draggable: true,
					}
				}
			break;
		}

		const media = slider.dataset.swiperMedia

		if (!media) {
			const swiper = new Swiper(slider, {...config })
			return
		}

		const sliderConfig = {...config }
		const query = window.matchMedia(media)
		let swiper = null

		const update = () => {
			if (!slider.isConnected) {
				query.removeEventListener('change', update)
				swiper?.destroy(true, true)
				return
			}

			if (query.matches && !swiper) {
				swiper = new Swiper(slider, {...sliderConfig })
			} else if (!query.matches && swiper) {
				swiper.destroy(true, true)
				swiper = null
			}
		}

		query.addEventListener('change', update)
		update()
	})
}
